import React from 'react'
import { Link } from 'react-router-dom'
import './LRTableRow.css'

const LRTableRowLinkUI = ({context, to, left, right}) =>
  <Link className={`w_lr_tbl_r g_flex_h active`} to={to}>
    <div className='left'>
      {left}
    </div>
    <div className='right'>
      {right}
    </div>
  </Link>

export default LRTableRowLinkUI
